"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
const config_1 = __importDefault(require("../config"));
class Users {
    static async GetCurrent() {
        try {
            const options = {
                withCredentials: true
            };
            let url = `${config_1.default.ONLINE_API_URL}/api/users/me`;
            let response = await axios_1.default.get(url, options);
            return response.data;
        }
        catch (e) {
            let message = `Can't access API server at this moment, please try again later`;
            if (e.response && e.response.data && e.response.data.detail) {
                message = e.response.data.detail;
            }
            return {
                message: message,
                error: 1
            };
        }
    }
    static async GetListing() {
        try {
            const options = {
                withCredentials: true
            };
            let url = `${config_1.default.ONLINE_API_URL}/api/v1/admin/users/list`;
            let response = await axios_1.default.get(url, options);
            return response.data;
        }
        catch (e) {
            let message = `Can't access API server at this moment, please try again later`;
            if (e.response && e.response.data && e.response.data.detail) {
                message = e.response.data.detail;
            }
            return {
                message: message,
                error: 1
            };
        }
    }
    static async Create(data) {
        try {
            const options = {
                withCredentials: true
            };
            let url = `${config_1.default.ONLINE_API_URL}/api/v1/admin/users/create-user`;
            let response = await axios_1.default.post(url, { ...data }, options);
            return response.data;
        }
        catch (e) {
            let message = `Can't access API server at this moment, please try again later`;
            if (e.response && e.response.data && e.response.data.detail) {
                message = e.response.data.detail;
            }
            return {
                message: message,
                error: 1
            };
        }
    }
    static async Edit(data) {
        try {
            const options = {
                withCredentials: true
            };
            let url = `${config_1.default.ONLINE_API_URL}/api/v1/admin/users/edit`;
            let response = await axios_1.default.post(url, { ...data }, options);
            return response.data;
        }
        catch (e) {
            let message = `Can't access API server at this moment, please try again later`;
            if (e.response && e.response.data && e.response.data.detail) {
                message = e.response.data.detail;
            }
            return {
                message: message,
                error: 1
            };
        }
    }
    static async Delete(username) {
        try {
            let url = `${config_1.default.ONLINE_API_URL}/api/v1/admin/users/delete?username=${username}`;
            let response = await axios_1.default.delete(url, { withCredentials: true });
            return response.data;
        }
        catch (e) {
            let message = `Can't access API server at this moment, please try again later`;
            if (e.response && e.response.data && e.response.data.detail) {
                message = e.response.data.detail;
            }
            return {
                message: message,
                error: 1
            };
        }
    }
    static async AssignOrganization(data) {
        try {
            const options = {
                withCredentials: true
            };
            let url = `${config_1.default.ONLINE_API_URL}/api/v1/admin/users/assign-organization`;
            let response = await axios_1.default.post(url, { ...data, role: 'merchandiser' }, options);
            return response.data;
        }
        catch (e) {
            let message = `Can't access API server at this moment, please try again later`;
            if (e.response && e.response.data && e.response.data.detail) {
                message = e.response.data.detail;
            }
            return {
                message: message,
                error: 1
            };
        }
    }
}
exports.default = Users;
